import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiNeutralFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 .5C1.438.5.5 1.438.5 8s.938 7.5 7.5 7.5 7.5-.937 7.5-7.5S14.563.5 8 .5M4.332 7.032h2.666v-1.4H4.332zm7.332 0H8.998v-1.4h2.666zM9.998 12.03h-4v-1.4h4z"
                fill="currentColor"
            />
        </g>
    </svg>
));
EmojiNeutralFilledSize16Glyph.displayName = 'EmojiNeutralFilledSize16Glyph';
